import * as Comlink from 'comlink'

export const fetchTrackingPositions = async (
  graphqlEndpoint: string,
  query: string,
  variables: {
    cameraId: string
    start: number
    end: number
    minIntervalMs?: number
  }
) => {
  const body = { operationName: null, variables, query }
  const res = await fetch(graphqlEndpoint, {
    headers: {
      accept: '*/*',
      'content-type': 'application/json',
      'sec-fetch-dest': 'empty',
      'sec-fetch-mode': 'cors',
      'sec-fetch-site': 'same-origin'
    },
    body: JSON.stringify(body),
    method: 'POST',
    mode: 'cors',
    credentials: 'omit'
  })
  const { data } = await res.json()
  return data as { physicalEntities: any | null }
}

const workerObject = { fetchTrackingPositions }

Comlink.expose(workerObject)
